<template>
  <div class="fragment">
    <OrdersFBAHead
        :showFilter="showFilter"
        :countFilterParams="countFilterParams"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @reload="$emit('reload')"
        @selectAll="selectAll"
    />

    <div class="table-filter-wrap">

      <OrdersFBAFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          @close="closeFilter"
          @changeFilter="data => $emit('changeFilter', data)"
          @resetFilter="$emit('resetFilter')"
      />

      <OrdersFBATable
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
          :countFilterParams="countFilterParams"
          @reload="$emit('reload')"
          :selectedNow="selectedNow"
          @downloadFiles="type => $emit('downloadFiles', type)"
      />
    </div>
  </div>
</template>

<script>
  import OrdersFBAHead from "./OrdersFBAHead/OrdersFBAHead";
  import OrdersFBAFilter from "./OrdersFBAFilter/OrdersFBAFilter";
  import OrdersFBATable from "./OrdersFBATable/OrdersFBATable.vue";

  export default {
    name: "OrdersFBATableContent",

    components: {
      OrdersFBAHead,
      OrdersFBAFilter,
      OrdersFBATable,
    },

    props: {
      countFilterParams: Number,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        selectedNow: false,
        isModalStatusOrderDetailsPopup: false
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
